var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{ref:"modal",staticClass:"select-modal",attrs:{"name":"selectModal","click-to-close":false,"width":729,"height":346},on:{"before-open":_vm.beforeOpen,"closed":_vm.closed}},[_c('select-content',_vm._b({attrs:{"is-upload":_vm.isUpload,"click-only":_vm.clickOnly,"upload-btn-tip":_vm.uploadBtnTip}},'select-content',_vm.callbacks,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }